__webpack_require__.p = "https://s3-us-west-2.amazonaws.com/aws-codestar-us-west-2-130456326821-friendlaura-app/public/";